export function normalizeHexColor(value: string): string {
  if (!/^#(?:[a-f\d]{3}|[a-f\d]{6})$/i.test(value)) return '#1e5b8c';
  return value.length === 4
    ? '#' + [...value.slice(1)].map((channel) => channel + channel).join('')
    : value.toLowerCase();
}

function channels(value: string): number[] {
  const color = normalizeHexColor(value);
  return [1, 3, 5].map((offset) => parseInt(color.slice(offset, offset + 2), 16));
}

export function contrastRatio(foreground: string, background: string): number {
  function luminance(color: string): number {
    const linear = channels(color).map((channel) => {
      const normalized = channel / 255;
      return normalized <= 0.04045 ? normalized / 12.92 : ((normalized + 0.055) / 1.055) ** 2.4;
    });
    return linear[0] * 0.2126 + linear[1] * 0.7152 + linear[2] * 0.0722;
  }
  const first = luminance(foreground);
  const second = luminance(background);
  return (Math.max(first, second) + 0.05) / (Math.min(first, second) + 0.05);
}

export function mixColors(color: string, target: string, amount: number): string {
  const targetChannels = channels(target);
  return (
    '#' +
    channels(color)
      .map((channel, index) =>
        Math.round(channel + (targetChannels[index] - channel) * amount)
          .toString(16)
          .padStart(2, '0'),
      )
      .join('')
  );
}

export function readableColor(color: string, background: string, target: string): string {
  const normalized = normalizeHexColor(color);
  for (let step = 0; step <= 100; step++) {
    const candidate = mixColors(normalized, target, step / 100);
    if (contrastRatio(candidate, background) >= 4.5) return candidate;
  }
  return target;
}

export function contrastingText(background: string): string {
  return contrastRatio('#ffffff', background) >= 4.5 ? '#ffffff' : '#0f1d2d';
}
